<template>
  <div class="attachments-wrap">
    <t-tabs :items="tabNavItems" />
    <router-view> </router-view>
  </div>
</template>

<script>
import TTabs from "@/components/TTabs";

export default {
  name: "Attachments",
  components: {
    TTabs,
  },
  data() {
    return {
      tabNavItems: this.$secondaryNav.userAttachmentsFiltering(),
    };
  },
};
</script>
